import React from "react";
import { Card, List, Table, Typography } from "antd";

export const CurrencyDetails = ({ currency }) => {
  const {
    to,
    flex,
    currency: currencyName,
    createdAt,
    updatedAt,
    comments,
  } = currency;
  const columns = [
    {
      title: "Target Currency",
      dataIndex: "targetCurrency",
      key: "targetCurrency",
    },
    {
      title: "Black Market Rate",
      dataIndex: "blackmarketRate",
      key: "blackmarketRate",
    },
    {
      title: "Official Rate",
      dataIndex: "officialRate",
      key: "officialRate",
    },
    {
      title: "IATA Rate",
      dataIndex: "iataRate",
      key: "iataRate",
    },
  ];
  const data = Object.entries(to).map(([targetCurrency, rates], index) => ({
    key: index,
    targetCurrency,
    ...rates,
  }));
  const commissionColumns = [
    { title: "Airline", dataIndex: "airline", key: "airline" },
    {
      title: "Original Percentage",
      dataIndex: "originalPercentage",
      key: "originalPercentage",
    },
    {
      title: "Discounted Percentage",
      dataIndex: "discountedPercentage",
      key: "discountedPercentage",
    },
  ];
  const commissionData = Object.entries(flex?.commission || {}).map(
    ([commissionType, commission]) => ({
      key: commissionType,
      airline: commissionType,
      originalPercentage: commission.originalPercentage,
      discountedPercentage: commission.discountedPercentage,
    })
  );
  return (
    <div className="currency-details">
      <Typography.Title level={4}>
        Conversion rates ({currencyName})
      </Typography.Title>
      <Table columns={columns} dataSource={data} />
      {flex && currencyName !== "USD" && (
        <Card title="Flex Commission" className="currency-details__section">
          <Table
            size="small"
            columns={commissionColumns}
            dataSource={commissionData}
            pagination={false}
          />
        </Card>
      )}

      <Typography.Title level={4} className="currency-details__section">
        Update history
      </Typography.Title>
      <List
        bordered
        dataSource={comments}
        renderItem={(comment) => <List.Item>{comment}</List.Item>}
      />
    </div>
  );
};
